import {useEffect} from "react"
import {handelTitle} from '../../utils'
import './PhysicalGoods.css'
import {Link} from "@tanstack/react-router"
import Breadcrumb from "../../components/Breadcrumb"
import { useI18n } from '../../i18n/context'

const PhysicalGoodsContainer = () => {
  const { t } = useI18n()

  useEffect(() => {
    handelTitle(t('containers.physicalGoods.title'))
  }, [])

  const features = [
    {
      title: t('containers.physicalGoods.listYourItems'),
      desc: t('containers.physicalGoods.listYourItemsDesc'),
      icon: '📦'
    },
    {
      title: t('containers.physicalGoods.auctionFormat'),
      desc: t('containers.physicalGoods.auctionFormatDesc'),
      icon: '🔨'
    },
    {
      title: t('containers.physicalGoods.buyItNow'),
      desc: t('containers.physicalGoods.buyItNowDesc'),
      icon: '⚡'
    },
    {
      title: t('containers.physicalGoods.flexiblePayments'),
      desc: t('containers.physicalGoods.flexiblePaymentsDesc'),
      icon: '💰'
    },
    {
      title: t('containers.physicalGoods.sellerProtection'),
      desc: t('containers.physicalGoods.sellerProtectionDesc'),
      icon: '🛡️'
    },
    {
      title: t('containers.physicalGoods.globalShipping'),
      desc: t('containers.physicalGoods.globalShippingDesc'),
      icon: '🌍'
    },
  ]

  return (
    <>
      <main className="main-content" style={{ paddingTop: '8px' }}>
      <Breadcrumb text1="Home" text2={t('containers.physicalGoods.title') as any}/>
      <div className="container-fluid py-4">

          <div className="row">
            <div className="col-12">

              {/* Page Header */}
              <div className="pixel-card mb-4">
                <div className="card-body p-4 text-center">
                  <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🏪</div>
                  <h1 className="mb-2">{t('containers.physicalGoods.title')}</h1>
                  <p className="text-secondary mb-0 lead" style={{ opacity: 0.8, maxWidth: '800px', margin: '0 auto' }}>
                    {t('containers.physicalGoods.header')}
                  </p>
                  <div className="mt-3">
                    <span className="badge bg-primary px-3 py-2">{t('containers.physicalGoods.workInProgress')}</span>
                    <span className="badge bg-secondary px-3 py-2 ms-2">{t('containers.physicalGoods.expectedQ2')}</span>
                  </div>
                </div>
              </div>

              {/* Feature Preview */}
              <div className="row mb-5">
                <div className="col-12 text-center mb-4">
                  <h2 className="h4 text-white">{t('containers.physicalGoods.comingTitle')}</h2>
                  <p className="text-muted">
                    {t('containers.physicalGoods.comingDesc')}
                  </p>
                </div>
                {features.map((feature, i) => (
                  <div key={i} className="col-md-6 col-lg-4 mb-4">
                    <div className="pixel-card h-100">
                      <div className="card-body text-center p-4">
                        <div className="display-4 mb-3">{feature.icon}</div>
                        <h5 className="card-title text-primary mb-2">{feature.title}</h5>
                        <p className="card-text text-muted small">{feature.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Info Section */}
              <div className="pixel-card mb-5">
                <div className="card-header bg-transparent border-0 pt-4 px-4">
                  <h2 className="h5 mb-0">{t('containers.physicalGoods.howItWorks')}</h2>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <h6 className="text-primary mb-3">{t('containers.physicalGoods.forSellers')}</h6>
                      <ul className="text-muted small">
                        <li className="mb-2">✓ {t('containers.physicalGoods.seller1')}</li>
                        <li className="mb-2">✓ {t('containers.physicalGoods.seller2')}</li>
                        <li className="mb-2">✓ {t('containers.physicalGoods.seller3')}</li>
                        <li className="mb-2">✓ {t('containers.physicalGoods.seller4')}</li>
                        <li className="mb-2">✓ {t('containers.physicalGoods.seller5')}</li>
                        <li className="mb-2">✓ {t('containers.physicalGoods.seller6')}</li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <h6 className="text-primary mb-3">{t('containers.physicalGoods.forBuyers')}</h6>
                      <ul className="text-muted small">
                        <li className="mb-2">✓ {t('containers.physicalGoods.buyer1')}</li>
                        <li className="mb-2">✓ {t('containers.physicalGoods.buyer2')}</li>
                        <li className="mb-2">✓ {t('containers.physicalGoods.buyer3')}</li>
                        <li className="mb-2">✓ {t('containers.physicalGoods.buyer4')}</li>
                        <li className="mb-2">✓ {t('containers.physicalGoods.buyer5')}</li>
                        <li className="mb-2">✓ {t('containers.physicalGoods.buyer6')}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="text-center mb-6">
                <p className="text-muted">
                  {t('containers.physicalGoods.interestedSelling')}{' '}
                  <Link to="/contact" className="text-primary text-decoration-none fw-bold">{t('containers.physicalGoods.contactUs') as any}</Link>
                  {' '}{t('containers.physicalGoods.learnMore')}
                </p>
                <p className="text-muted small mt-2">
                  {t('containers.physicalGoods.meanwhileExplore')}{' '}
                  <Link to="/" className="text-primary text-decoration-none">{t('containers.physicalGoods.nftMarketplace') as any}</Link>
                  {' '}{t('containers.physicalGoods.or')}{' '}
                  <Link to="/faq" className="text-primary text-decoration-none">{t('containers.physicalGoods.faq') as any}</Link>.
                </p>
              </div>

            </div>
          </div>
        </div>
      </main>
    </>
  )
};

export default PhysicalGoodsContainer
